(function() {
  $(document).ready(function () {
    updatePrice();
  });

  $(document).delegate('.rtx-subscription-dropdown', 'change', function () {
    var value = $(this).val();
    var dataAttrs = $(this).find('option:selected').data();

    $('.bundle-product-list-items .bundle-product-list-item').each(function() {
      $(this).attr('data-selling-plan-id', dataAttrs.sellingPlanId);
    });
    
    updatePrice();
  });

  $(document).delegate('.bundle-product-purchase-options .rtx-subscription-label', 'click', function () {
    $(".bundle-product-purchase-options .rtx-subscription-label").removeClass("is-selected");
    $(this).addClass("is-selected");
  })
  
  
  $(document).delegate(".bundle-quantity-container .bundle-add-btn.isactive", "click", function() {
    $(this).removeClass('isactive');
    $(this).next('.bundle-quantity-box').addClass('isactive');
    $(this).parents('.bundle-product-list-item').addClass('item-active');
    var qtyDisplay = $(this).parents('.bundle-quantity-container').find('.bundle-qty-display');
    qtyDisplay.text(1);
    updatePrice();
  });
  
  $(document).delegate(".bundle-quantity-container .qty-button-plus", "click", function() {
    var ele = $(this);
    qtyPlusMinus(ele);
  });
  
  $(document).delegate(".bundle-quantity-container .qty-button-minus", "click", function() {
    var ele = $(this);
    var qty = -1;
    qtyPlusMinus(ele, qty);
  });
  
  function qtyPlusMinus(ele, qty = 1) {
    var qtyDisplay = ele.parents('.bundle-quantity-box').find('.bundle-qty-display');
    var qtyDisplayText = qtyDisplay.text();
  
    if (parseInt(qty) == 1) {
      qtyDisplay.text(parseInt(qtyDisplayText)+parseInt(qty));
    } else if (parseInt(qtyDisplayText) > 1) {
      qtyDisplay.text(parseInt(qtyDisplayText)+parseInt(qty));
    } else {
      qtyDisplay.text(0);
      ele.parents('.bundle-quantity-box').removeClass('isactive');
      ele.parents('.bundle-product-list-item').removeClass('item-active');
      ele.parents('.bundle-quantity-container').find('.bundle-add-btn').addClass('isactive');
    }

    updatePrice();
  }

  $(document).delegate('.bundle_content_wrapper input[name="purchaseType"]', "change", function () {
    updatePrice();
  });

  function formatPrice(price = 0) {

    var symbol = window.currencySymbol || '$';
    var code = window.currencyCode || 'USD';

    var formattedPrice = (price / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: code
    });

    return formattedPrice;
  }

  function updatePrice() {
    var $totalregularprice = 0;
    var $recurringprice = 0;
    var $sqty = 0;

    $(".bundle-product-list-items .bundle-product-list-item.item-active").each(function(){
      var $dataprice = parseInt($(this).attr("data-price")) * parseInt($(this).find(".bundle-qty-display").text());
      var $datarecuu = parseInt($(this).attr("data-recurring-price")) * parseInt($(this).find(".bundle-qty-display").text());
      $totalregularprice = $totalregularprice + $dataprice;
      $recurringprice = $recurringprice + $datarecuu;
      $sqty = $sqty + parseInt($(this).find(".bundle-qty-display").text());
    })
    $(".rtx-subscription-label__inner s").text(formatPrice($totalregularprice));
    $(".rtx-subscription-label__inner .rtx-price__wrapper span").text(formatPrice($recurringprice));
    $(".bundle_content_wrapper .rtxonetime").text(formatPrice($totalregularprice));

  
    $(".bags-options .bag").each(function(){
      var $bagqty = parseInt($(this).attr("data-bag-count"));
      if($bagqty <= $sqty ){
        $(this).addClass("active");
      } else {
        $(this).removeClass("active");
      }
    })

  }

  $(document).delegate("#bundle_buy_button", "click", function(e) {
    var $purchasetype = $('.bundle-product-purchase-options input[name="purchaseType"]:checked').val();
    var items = [];
    console.log($purchasetype);
    $('.bundle-product-list-items .bundle-product-list-item.item-active').each(function() {
      var productId = $(this).data('variant-id');
      var quantity = $(this).find('.bundle-qty-display').text();
      var sellingPlanId = $(this).data('selling-plan-id');

      if($purchasetype == "purchaseTypeSubscription"){
        items.push({
          id: productId,
          quantity: parseInt(quantity),
          selling_plan: sellingPlanId
        });
      } else {
        items.push({
          id: productId,
          quantity: parseInt(quantity)
        });
      }
    });

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: JSON.stringify({ items: items }),
      dataType: 'json',
      contentType: 'application/json',
      success: function(data) {

      },
      error: function(err) {

      }
    });
  });


})();